export const BORDER_STYLES = {
	SOLID: 'solid',
	DOTTED: 'dotted',
	DASHED: 'dashed'
}
